module.exports = __webpack_public_path__ + "static/media/question_mark_circle.40108d60.svg";